import { takeEvery, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions'
import axios from '../services';
import { sessionExpiredMsg } from "../constants/constants";

function* getUser(action) {
    try {
        let response = yield axios
            .get("/users")
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        let enrolledContest = yield axios
            .get("/users/user-enrolled-contests")
            .then(async response => response)
            .catch(async error => {
                return error;
            });

    
        if (response.status != undefined && response.status == 200) {
            yield localStorage.setItem(
                "userData",
                JSON.stringify(response.data.data)
            );
            if (action.payload != undefined) {
                if (action.payload.country == 0) {
                    yield put(actions.getCountryList());
                }
                if (action.payload.province == 0) {
                    yield put(actions.getProvinceList(response.data.data.locationInfo.country));
                }
                if (action.payload.city == 0) {
                    yield put(actions.getCityList(response.data.data.locationInfo.state));
                }
            }
            response.data.data.enrolledContests = enrolledContest.data.data;
            yield put(actions.getUserSuccess(response.data.data));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }

        if (enrolledContest == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (enrolledContest.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        // if (error == "Error: Request failed with status code 401") {
        //     yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        // }
        // if (error == "Error: Request failed with status code 500") {
        //     yield put(actions.hideAppLoader());
        //     yield put(actions.modalOpen({ message: error.response.data.msg }));
        // }
        console.log("Saga ERROR FROM SAGA USER", error);
    }
}

function* userFeedback(action) {
    const { firstName, lastName, countryCode, phone, email, feedback } = action.payload;
    let user = JSON.parse(localStorage.getItem('userData'));
    try {
        let response = yield axios.post("users/give-feedback", {
            givenBy: user._id,
            firstName,
            lastName,
            countryCode,
            phone,
            email,
            message: feedback
        }).then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response.status == 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2 }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {

        yield put(actions.hideAppLoader());
        console.log("ERROR FROM USER SAGA", error)
    }
}

function* postContactUsData(action) {
    const { firstName, lastName, countryCode, phone, email, feedback } = action.payload;
    let user = JSON.parse(localStorage.getItem('userData'));
    try {
        let response = yield axios.post("users/contact-us", {
            givenBy: user._id,
            firstName,
            lastName,
            countryCode,
            phone,
            email,
            message: feedback
        }).then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response.status == 200) {
            yield put(actions.hideAppLoader())
            yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2 }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        if (error.data != undefined && error.data.isVerify == false) {
        } else {
        }
        yield put(actions.hideAppLoader());
        console.log("EERROR FROM USER SAGA")
    }
}

function* changeUserPassword(action) {
    const { oldPassword, newPassword } = action.payload;
    let user = JSON.parse(localStorage.getItem('userData'));
    try {
        let response = yield axios.post("/users/change-password", {
            userId: user._id,
            oldPassword: oldPassword,
            newPassword: newPassword,
        })
        if (response.status == 200) {
            yield put(actions.hideAppLoader())
            yield put(actions.userChangePasswordSuccess());
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        yield put(actions.hideAppLoader());
        yield put(actions.modalOpen({ message: "Current password is wrong." }));
    }
}

function* getSavedPostData() {
    try {
        let response = yield axios.get('/users/user-bookmark-post')
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status == 200) {
            yield put(actions.getSavedPostDataSuccess({
                savedPost: response.data.data,
            }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {


    }
}

function* getMyVotesData(action) {
    try {
        let response = yield axios.get(`/votes/given-votes-detail?skip=${action.payload}&limit=10`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (response.status == 200) {
            console.log(response)
            yield put(actions.getMyVotesDataSuccess({ myVotes: response.data.data, newData: action.payload == 0 }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Saga error from user")

    }
}

function* evaluation(action) {
    try {
        let response = yield axios.post(`/users/contest/${action.payload.contestName}/endorse-user`, action.payload.evaluationData)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (response.status == 200) {
            yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2, redirectURL: action.payload.evaluationData.path }));
            yield put(actions.hideAppLoader());
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        //console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);

    }
}

function* changeNumber(action) {
    try {
        let response = yield axios.put(`users`, {
            tempCountry: action.payload.country,
            tempPhone: action.payload.phone,
            tempCountryCode: action.payload.countryCode
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (response.status == 200) {
            try {
                let response = yield axios.post(`/users/resend-otp`, {
                    phone: action.payload.phone,
                    countryCode: action.payload.countryCode,
                    temp: true
                })
                    .then(async response => response)
                    .catch(async error => {
                        return error;
                    });
                if (response == "Error: Request failed with status code 401") {
                    yield put(actions.hideAppLoader());
                    put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
                } else if (response.status == 200) {
                    yield put(actions.userChangePhoneNumberSuccess(true));
                } else {
                    yield put(actions.hideAppLoader());
                    yield put(actions.modalOpen({ message: response.response.data.msg }));
                }
            } catch (error) {
                if (error == "Error: Request failed with status code 401") {
                    yield put(actions.hideAppLoader());
                    yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
                } else if (error == "Error: Request failed with status code 500") {
                    yield put(actions.hideAppLoader());
                    yield put(actions.modalOpen({ message: error.response.data.msg }));
                }
            }
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {

    }
}
function* verifyNumber(action) {
    try {
        let response = yield axios.post(`users/verify-and-change-phone-number`, {
            tempAlpha: action.payload.countryCode,
            currentAlpha: action.payload.currentAlpha,
            userId: JSON.parse(localStorage.getItem('userData'))._id,
            otp: action.payload.otp
        }).then(async response => response).catch(async error => {
            return error;
        });

        console.log("Verify MEGHA", response)
        // yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2, redirectURL: action.payload.evaluationData.path }));
        if (response.status == 200) {
            yield put(actions.userPhoneNumberVerifySuccess());
            yield put(actions.modalOpen({
                message: response.data.msg, notifyType: 2, redirectURL: {
                    pathname: "/settings",
                    state: {
                        from: "changeNumber"
                    }
                }
            }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA", error);
    }
}
export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_USER, getUser);
    yield takeEvery(actionTypes.POST_USER_FEEDBACK, userFeedback);
    yield takeEvery(actionTypes.POST_CONTACT_US_DATA, postContactUsData);
    yield takeEvery(actionTypes.USER_CHANGE_PASSWORD_REQUEST, changeUserPassword);
    yield takeEvery(actionTypes.GET_SAVED_POST_DATA, getSavedPostData);
    yield takeEvery(actionTypes.EVALUATION, evaluation);
    yield takeEvery(actionTypes.GET_MY_VOTES_DATA, getMyVotesData);
    yield takeEvery(actionTypes.USER_CHANGE_PHONE_NUMBER_REQUEST, changeNumber); 
    yield takeEvery(actionTypes.USER_PHONE_NUMBER_VERIFY_REQUEST, verifyNumber);
}